import React from "react";
import { Lightbulb, LightbulbOff } from "lucide-react";

export const LightToggle = ({ lit, onChange }) => (
  <div
    data-testid="pdp-light-toggle"
    style={{ backgroundColor: "rgba(250, 244, 232, 0.88)" }}
    className="absolute bottom-4 left-4 flex backdrop-blur-md border border-[var(--sand)] text-[10px] tracking-[0.2em] uppercase"
  >
    {[
      { on: true, label: "Light on", Icon: Lightbulb },
      { on: false, label: "Light off", Icon: LightbulbOff },
    ].map(({ on, label, Icon }) => (
      <button
        key={label}
        type="button"
        onClick={() => onChange(on)}
        data-testid={on ? "pdp-light-on-btn" : "pdp-light-off-btn"}
        aria-pressed={lit === on}
        className={`flex items-center gap-2 px-4 h-10 transition-colors ${lit === on ? "bg-[var(--espresso)] text-[var(--cream)]" : "text-[var(--espresso)] hover:text-[var(--copper)]"}`}
      >
        <Icon className="w-3.5 h-3.5" strokeWidth={1.25} />
        {label}
      </button>
    ))}
  </div>
);
